// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: rgb(248, 249, 250) !important;
    overflow: hidden;
}

.header {
    background-color: rgba(247, 247, 247, 1);
    padding: 5px 50px 5px 50px;
}

.version-tag {
    font-size: 0.65rem;
    font-weight: 500;
    color: #a4a4a4;
    margin-top: 10px;
}

.search-area svg {
    z-index: 1;
    margin: auto;
}

.search-area .search-input {
    outline: none !important;
    border: none !important;
    margin-left: -40px;
    padding: 8px 50px;
    width: 400px;
}
.navigation-tabs {
    padding: 0px 50px 20px 50px;
}
.navigation-tabs button {
    width: 12.5%;
}
.content-section {
    flex: 1 1;
    overflow-y: auto;
    padding: 0px 50px 20px 50px;
    margin-top: -20px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

.content-section::-webkit-scrollbar {
    display: none;
}

.mobile-menu {
    display: none;
}

@media only screen and (max-width: 1200px) and (min-width: 600px) {
    .header {
        background-color: rgba(247, 247, 247, 1);
        padding: 5px 20px 10px 20px;
    }
    .headerSearch {
        margin-top: 30px !important;
        padding: 0px 20px;
        width: 90vw !important;
    }
    .navigation-tabs {
        padding: 20px;
        font-size: 12px !important;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: start !important;
    }
    .navigation-tabs button {
        display: inline-block;
        width: auto;
        padding: 5px 20px;
    }
}

@media only screen and (max-width: 600px) and (min-width: 300px) {
    .header {
        background-color: rgba(247, 247, 247, 1);
        padding: 5px 20px 10px 20px;
    }
    .headerSearch {
        margin-top: 30px !important;
        padding: 0px 20px;
        width: 90vw !important;
    }
    .mobile-menu {
        display: block;
    }
    /* .navigation-tabs {
        padding: 20px;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: start !important;
    } */
    .navigation-tabs {
        display: none !important;
    }
    /* .navigation-tabs button {
        display: inline-block;
        width: auto;
        padding: 5px 20px;
    } */
    .content-section {
        overflow-y: auto;
        height: 86vh;
        padding: 20px;
        margin-top: -20px;
    }
}

@media only screen and (max-width: 1200px) {
    .layout {
        height: 100vh;
        background-color: rgb(248, 249, 250) !important;
    }
}

.sticky-thead th {
    position: sticky;
    top: 130px; /* Offset for taller page headers (e.g. User Management) */
    z-index: 10;
    background-color: #f8f9fa !important;
    border-bottom: 2px solid #dee2e6;
}
`, "",{"version":3,"sources":["webpack://./src/layout/layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;AAChB;AACA;IACI,SAAO;IACP,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,wBAAwB,EAAE,gBAAgB;IAC1C,qBAAqB,EAAE,YAAY;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,wCAAwC;QACxC,2BAA2B;IAC/B;IACA;QACI,2BAA2B;QAC3B,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,0BAA0B;QAC1B,eAAe;QACf,SAAS;QACT,iCAAiC;IACrC;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,wCAAwC;QACxC,2BAA2B;IAC/B;IACA;QACI,2BAA2B;QAC3B,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,cAAc;IAClB;IACA;;;;;OAKG;IACH;QACI,wBAAwB;IAC5B;IACA;;;;OAIG;IACH;QACI,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,+CAA+C;IACnD;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU,EAAE,0DAA0D;IACtE,WAAW;IACX,oCAAoC;IACpC,gCAAgC;AACpC","sourcesContent":[".layout {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background-color: rgb(248, 249, 250) !important;\n    overflow: hidden;\n}\n\n.header {\n    background-color: rgba(247, 247, 247, 1);\n    padding: 5px 50px 5px 50px;\n}\n\n.version-tag {\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: #a4a4a4;\n    margin-top: 10px;\n}\n\n.search-area svg {\n    z-index: 1;\n    margin: auto;\n}\n\n.search-area .search-input {\n    outline: none !important;\n    border: none !important;\n    margin-left: -40px;\n    padding: 8px 50px;\n    width: 400px;\n}\n.navigation-tabs {\n    padding: 0px 50px 20px 50px;\n}\n.navigation-tabs button {\n    width: 12.5%;\n}\n.content-section {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0px 50px 20px 50px;\n    margin-top: -20px;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n}\n\n.content-section::-webkit-scrollbar {\n    display: none;\n}\n\n.mobile-menu {\n    display: none;\n}\n\n@media only screen and (max-width: 1200px) and (min-width: 600px) {\n    .header {\n        background-color: rgba(247, 247, 247, 1);\n        padding: 5px 20px 10px 20px;\n    }\n    .headerSearch {\n        margin-top: 30px !important;\n        padding: 0px 20px;\n        width: 90vw !important;\n    }\n    .navigation-tabs {\n        padding: 20px;\n        font-size: 12px !important;\n        flex-wrap: wrap;\n        gap: 10px;\n        justify-content: start !important;\n    }\n    .navigation-tabs button {\n        display: inline-block;\n        width: auto;\n        padding: 5px 20px;\n    }\n}\n\n@media only screen and (max-width: 600px) and (min-width: 300px) {\n    .header {\n        background-color: rgba(247, 247, 247, 1);\n        padding: 5px 20px 10px 20px;\n    }\n    .headerSearch {\n        margin-top: 30px !important;\n        padding: 0px 20px;\n        width: 90vw !important;\n    }\n    .mobile-menu {\n        display: block;\n    }\n    /* .navigation-tabs {\n        padding: 20px;\n        flex-wrap: wrap;\n        gap: 10px;\n        justify-content: start !important;\n    } */\n    .navigation-tabs {\n        display: none !important;\n    }\n    /* .navigation-tabs button {\n        display: inline-block;\n        width: auto;\n        padding: 5px 20px;\n    } */\n    .content-section {\n        overflow-y: auto;\n        height: 86vh;\n        padding: 20px;\n        margin-top: -20px;\n    }\n}\n\n@media only screen and (max-width: 1200px) {\n    .layout {\n        height: 100vh;\n        background-color: rgb(248, 249, 250) !important;\n    }\n}\n\n.sticky-thead th {\n    position: sticky;\n    top: 130px; /* Offset for taller page headers (e.g. User Management) */\n    z-index: 10;\n    background-color: #f8f9fa !important;\n    border-bottom: 2px solid #dee2e6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
